export default __webpack_public_path__ + "static/media/privacy-black-icon.e3bd1921.svg";